import React, { useState, useEffect } from "react";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import { useMediaQuery } from "@chakra-ui/react";
import './Footer.css';
import { useTranslation } from './translations/useTranslation';
// Import Google font in index.html or add this line to index.css:
// @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
import ai from './Assets/Ai.png'

export default function Footer() {
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const [isHomePage, setIsHomePage] = useState(false);
  const { t } = useTranslation();
  
  useEffect(() => {
    // Check if current page is home page
    const path = window.location.pathname;
    setIsHomePage(path === '/' || path === '');
  }, []);
  
  // Return null if it's not the home page (for both mobile and desktop)
  if (!isHomePage) return null;
  
  return (
    <MDBFooter
      className="footer"
      style={{ backgroundColor: "#ffffff" }}
    >
      <section className="footer-social-section d-flex justify-content-center justify-content-lg-between px-4">
        <div className="me-5 d-none d-lg-block">
          <span style={{ fontSize: '1.1rem', fontWeight: '500', color: '#4a5568' }}>{t('connectSocial')}</span>
        </div>

        <div className="footer-social-icons">
          <a href="https://www.agromanch.com" aria-label="Website">
            <MDBIcon fa icon="globe" />
          </a>
          <a href="https://www.instagram.com/agromanch" aria-label="Instagram">
            <MDBIcon fab icon="instagram" />
          </a>
          <a href="https://www.facebook.com/agromanch" aria-label="Facebook">
            <MDBIcon fab icon="facebook" />
          </a>
          <a href="https://www.youtube.com/@AgroManch" aria-label="YouTube">
            <MDBIcon fab icon="youtube" />
          </a>
        </div>
      </section>

      <section className="footer-content text-dark">
        <MDBContainer className="text-center text-md-start">
          <MDBRow>
            <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
              <h6 className="footer-heading text-uppercase fw-bold">
                <MDBIcon icon="leaf" className="me-3" style={{ color: '#38a169' }} />
                {t('AgroManch')}
              </h6>
              <p style={{ lineHeight: '1.8', color: '#4a5568' }}>
                {t('footerAboutText')}
              </p>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className="mx-auto mb-4 footer-links">
              <h6 className="footer-heading text-uppercase fw-bold">{t('aboutUs')}</h6>
              <p>
                <a href="#!">
                  {t('ourStory')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('careers')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('contactUs')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('sustainability')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('partnerWithUs')}
                </a>
              </p>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className="mx-auto mb-4 footer-links">
              <h6 className="footer-heading text-uppercase fw-bold">{t('resources')}</h6>
              <p>
                <a href="#!">
                  {t('helpCenter')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('sitemap')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('privacyPolicy')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('farmingBlog')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('equipmentMarketplace')}
                </a>
              </p>
              <p>
                <a href="#!">
                  {t('farmerCommunity')}
                </a>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4 footer-contact-info">
              <h6 className="footer-heading text-uppercase fw-bold">{t('contact')}</h6>
              <p>
                <MDBIcon icon="home" className="me-2" />
                {t('address')}
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-3" />
                {t('email')}
              </p>
              <p>
                <MDBIcon icon="phone" className="me-3" /> {t('phone')}
              </p>
              <p>
                <MDBIcon icon="clock" className="me-3" /> {t('businessHours')}
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className="footer-copyright text-center p-4">
        © {new Date().getFullYear()} {t('copyright')}:
        <a className="ms-2" href="https://agroconnect.com/">
          {t('websiteUrl')}
        </a>
        {/* <div className="container">
          <div className="made-by mt-3">
            {t('madeWith')} <MDBIcon fas icon="heart" className="mx-1" style={{ color: '#f56565' }} /> {t('by')} <span> <a className="ms-2" href="https://www.linkedin.com/in/anuj-kumar-a7954a257/">{t('developerName')}</a></span>
          </div>
        </div> */}
      </div>
    </MDBFooter>
  );
}
